import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getPopularCareers = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/elementary/careers/liked/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getPopularCareersLikers = ({
  careerId,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/elementary/careers/${careerId}/likers/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getPopularCareersLikersHash = ({
  careerId,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/elementary/careers/${careerId}/likers/hash/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getPopularCareersLikersExport = ({
  careerId,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/elementary/careers/${careerId}/likers/export/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getPopularCareerGroups = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/elementary/career-groups/liked/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getPopularCareerGroupsLikers = ({
  careerGroupId,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/elementary/career-groups/${careerGroupId}/likers/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getPopularCareerGroupsLikersHash = ({
  careerGroupId,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/elementary/career-groups/${careerGroupId}/likers/hash/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getPopularCareerGroupsLikersExport = ({
  careerGroupId,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/elementary/career-groups/${careerGroupId}/likers/export/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentCompletionResults = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/elementary/quizzes/completion/options/grades/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentCompletionResultsLikers = ({
  gradeId,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/elementary/quizzes/completion/options/grades/${gradeId}/students/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentCompletionResultsLikersHash = ({
  gradeId,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/elementary/quizzes/completion/options/grades/${gradeId}/students/hash/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentCompletionResultsLikersExport = ({
  gradeId,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/elementary/quizzes/completion/options/grades/${gradeId}/students/export/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getBreakdownResults = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/elementary/quizzes/completion/assessment-breakdown/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getBreakdownResultsLikers = ({
  answerId,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/elementary/quizzes/answer-options/${answerId}/students/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getBreakdownResultsLikersHash = ({
  answerId,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/elementary/quizzes/answer-options/${answerId}/students/hash/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getBreakdownResultsLikersExport = ({
  answerId,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/elementary/quizzes/answer-options/${answerId}/students/export/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getEvents = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/analytics/events/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentInterestFeed = ({
  studentId,
  params,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/elementary/careers/student-career-interest-feed/${studentId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFavoritedCareersPerGroup = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/elementary/career-groups/liked/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentQuizzes = ({ params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/elementary/student-quizzes/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getQuiz = ({ quizId, params, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/elementary/student-quizzes/${quizId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
